var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect, useContext } from 'react';
import AppContext from '../../../../context';
import { FormWrapper } from '../../form-wrapper';
import { ColorPicker, InputNumberFiled, InputFiled, SelectField } from './fields';
import { prefix } from './constants';
export var ArrowConfig = {
    width: 12,
    height: 8,
    name: 'block',
};
export var DisableArrowConfig = {
    width: 0,
    height: 0,
    name: '',
};
export var ArrowMaps = {
    target: {
        sourceMarker: DisableArrowConfig,
        targetMarker: ArrowConfig,
    },
    source: {
        sourceMarker: ArrowConfig,
        targetMarker: DisableArrowConfig,
    },
    all: {
        sourceMarker: ArrowConfig,
        targetMarker: ArrowConfig,
    },
    none: {
        sourceMarker: DisableArrowConfig,
        targetMarker: DisableArrowConfig,
    },
};
export var ArrowStrokeMaps = {
    solid: [0, 0],
    dash: [5, 5],
};
var EdgeComponent = function (props) {
    var config = props.config, _a = props.plugin, plugin = _a === void 0 ? {} : _a;
    var updateEdge = plugin.updateEdge;
    var EdgeConfig = useContext(AppContext).theme.EdgeConfig;
    var _b = useState(__assign(__assign({}, EdgeConfig.normal), config)), edgeConfig = _b[0], setEdgeConfig = _b[1];
    useEffect(function () {
        setEdgeConfig(__assign(__assign({}, EdgeConfig.normal), config));
    }, [config]);
    var getAttrs = function (key, type) {
        var _a;
        if (type === void 0) { type = 'line'; }
        var _b = edgeConfig.attrs, attrs = _b === void 0 ? {} : _b;
        return (_a = attrs[type]) === null || _a === void 0 ? void 0 : _a[key];
    };
    var getArrowValue = function () {
        var _a, _b, _c, _d, _e;
        var _f = edgeConfig.attrs, attrs = _f === void 0 ? {} : _f;
        var _g = attrs.line, line = _g === void 0 ? {} : _g;
        if (((_a = line.sourceMarker) === null || _a === void 0 ? void 0 : _a.name) && ((_b = line.targetMarker) === null || _b === void 0 ? void 0 : _b.name)) {
            return 'all';
        }
        if (!((_c = line.sourceMarker) === null || _c === void 0 ? void 0 : _c.name) && !((_d = line.targetMarker) === null || _d === void 0 ? void 0 : _d.name)) {
            return 'none';
        }
        if ((_e = line.sourceMarker) === null || _e === void 0 ? void 0 : _e.name) {
            return 'source';
        }
        return 'target';
    };
    var getSrokeDashValue = function () {
        var _a = edgeConfig.attrs, attrs = _a === void 0 ? {} : _a;
        var _b = attrs.line, line = _b === void 0 ? {} : _b;
        return line.strokeDasharray ? 'dash' : 'solid';
    };
    var onEdgeConfigChange = function (key, value, type) {
        var _a, _b, _c, _d, _e;
        var _f, _g;
        if (type === void 0) { type = 'line'; }
        /** 全量更新，简化逻辑 */
        if (key === 'arrow') {
            setEdgeConfig(__assign(__assign({}, edgeConfig), { attrs: __assign(__assign({}, edgeConfig.attrs), (_a = {}, _a[type] = __assign(__assign({}, (_f = edgeConfig.attrs) === null || _f === void 0 ? void 0 : _f[type]), value), _a)) }));
        }
        else {
            setEdgeConfig(__assign(__assign({}, edgeConfig), (_b = {}, _b[key] = value, _b.attrs = __assign(__assign({}, edgeConfig.attrs), (_c = {}, _c[type] = __assign(__assign({}, (_g = edgeConfig.attrs) === null || _g === void 0 ? void 0 : _g[type]), (_d = {}, _d[key] = value, _d)), _c)), _b)));
        }
        updateEdge((_e = {},
            _e[key] = value,
            _e), type, key === 'arrow' ? 'arrow' : '');
    };
    return (React.createElement("div", { className: "".concat(prefix, "-panel-body") },
        React.createElement("div", { className: "".concat(prefix, "-panel-group") },
            React.createElement("h5", null, "\u5185\u5BB9"),
            React.createElement(InputFiled, { label: "\u6807\u7B7E", value: edgeConfig.label, onChange: function (value) {
                    onEdgeConfigChange('label', value);
                } })),
        React.createElement("h5", { style: { marginBottom: 12 } }, "\u6837\u5F0F"),
        React.createElement("div", { className: "".concat(prefix, "-panel-group"), style: { marginBottom: 0 } },
            React.createElement("h5", null, "\u7EBF"),
            React.createElement(SelectField, { label: "\u7BAD\u5934", value: getArrowValue(), options: [
                    {
                        label: '正向',
                        value: 'target',
                    },
                    {
                        label: '逆向',
                        value: 'source',
                    },
                    {
                        label: '双向',
                        value: 'all',
                    },
                    {
                        label: '无',
                        value: 'none',
                    },
                ], onChange: function (value) {
                    onEdgeConfigChange('arrow', ArrowMaps[value], 'line');
                } }),
            React.createElement("div", { className: "".concat(prefix, "-edge-stroke-style") },
                React.createElement(SelectField, { label: "\u7EBF\u5F62", width: 68, value: getSrokeDashValue(), options: [
                        {
                            label: '实线',
                            value: 'solid',
                        },
                        {
                            label: '虚线',
                            value: 'dash',
                        },
                    ], onChange: function (value) {
                        onEdgeConfigChange('strokeDasharray', ArrowStrokeMaps[value], 'line');
                    } }),
                React.createElement(InputNumberFiled, { value: getAttrs('strokeWidth'), min: 1, onChange: function (value) {
                        onEdgeConfigChange('strokeWidth', value, 'line');
                    } })),
            React.createElement(ColorPicker, { label: "\u8FB9\u6846", value: getAttrs('stroke'), onChange: function (value) {
                    onEdgeConfigChange('stroke', value, 'line');
                } })),
        React.createElement("div", { className: "".concat(prefix, "-panel-group") },
            React.createElement("h5", null, "\u6807\u7B7E"),
            React.createElement("div", { className: "".concat(prefix, "-edge-text-style") },
                React.createElement(InputNumberFiled, { label: "\u5B57\u53F7", min: 10, width: 68, value: getAttrs('fontSize', 'text') || 12, onChange: function (value) {
                        onEdgeConfigChange('fontSize', value, 'text');
                    } }),
                React.createElement(ColorPicker, { value: getAttrs('fill', 'text') || '#000', onChange: function (value) {
                        onEdgeConfigChange('fill', value, 'text');
                    } })))));
};
export var EdgeService = function (props) {
    return (React.createElement(FormWrapper, __assign({}, props, { type: "edge" }), function (config, plugin) { return React.createElement(EdgeComponent, __assign({}, props, { plugin: plugin, config: config })); }));
};
